import * as types from "state/entities/userTeamFavorites/userTeamFavoritesTypes";
import { omit, isEmpty } from "lib/lodash";

export const initState = {
  pages: {},
  detailedIds: {},
  totalCount: null,
  pageSize: 50
};

export const handleUserTeamFavoriteRequest = ({ action, state }) => {
  const { page } = action.request;
  return {
    ...state,
    pages: {
      ...state.pages,
      [page]: {
        ...state.pages[page],
        isFetching: true
      }
    }
  };
};

export const handleUserTeamFavoriteRequestSuccess = ({ state, action }) => {
  const {
    response: { ids = [] } = {},
    request: { page }
  } = action;

  if (isEmpty(ids) && Number(page) !== 1) {
    return {
      ...state,
      pages: omit(state.pages, action.request.page)
    };
  }

  const updatedPage = {
    [page]: {
      isFetching: false,
      ids: ids,
      didInvalidate: false
    }
  };

  return {
    ...state,
    pages: { ...state.pages, ...updatedPage }
  };
};

const userTeamFavoritesApiReducers = (state = initState, action) => {
  switch (action.type) {
    case types.USER_TEAM_FAVORITES_REQUEST: {
      return handleUserTeamFavoriteRequest({ state, action });
    }

    case types.USER_TEAM_FAVORITES_REQUEST_SUCCESS: {
      return handleUserTeamFavoriteRequestSuccess({ state, action });
    }

    default:
      return state;
  }
};

export default userTeamFavoritesApiReducers;
